function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';
import styled from 'styled-components';
import { border, borderRadius, height, width } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import Box from '../Box';
import { FormGroupContext } from './FormGroup';
const StyledSelect = styled(Box).withConfig({
  displayName: "Select__StyledSelect",
  componentId: "sc-1rstcru-0"
})(["", " ", " ", " ", " &:hover{border-color:", ";}&:focus{border-color:", ";outline:none;}", " ", " ", ""], border, borderRadius, height, width, themeGet('colors.gray.5'), themeGet('colors.secondary'), props => props.hasError && `&, &:hover, &:focus { border-color: ${themeGet('colors.error')(props)}; }`, props => props.hasPrefix && `
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  `, props => props.hasSuffix && `
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  `);
const hasFormError = (name, form) => {
  return form && form.touched && form.touched[name] && form.errors && form.errors[name];
};
const Select = /*#__PURE__*/memo(_ref => {
  let {
    as = 'select',
    bg = 'white',
    border = 'default',
    borderRadius = 'corner',
    display = 'block',
    field,
    form,
    hasError = false,
    hasPrefix = false,
    hasSuffix = false,
    height = 40,
    maxWidth = '100%',
    px = 2,
    py = 2,
    width = '100%',
    ...props
  } = _ref;
  const id = useContext(FormGroupContext);
  return /*#__PURE__*/React.createElement(StyledSelect, _extends({
    as: as,
    bg: bg,
    border: border,
    borderRadius: borderRadius,
    display: display,
    height: height,
    id: id,
    hasError: field ? hasFormError(field.name, form) : hasError,
    hasPrefix: hasPrefix,
    hasSuffix: hasSuffix,
    maxWidth: maxWidth,
    px: px,
    py: py,
    width: width
  }, field, props));
});
Select.propTypes = {
  ...Box.propTypes,
  ...border.propTypes,
  ...borderRadius.propTypes,
  ...height.propTypes,
  ...width.propTypes,
  hasPrefix: PropTypes.bool,
  hasSuffix: PropTypes.bool
};
Select.displayName = 'Select';
export default Select;